/**
 * Utility function to get active color styles based on the activeColor prop
 * @param {string} activeColor - The active color theme (primary, secondary, tertiary, quaternary, quinary)
 * @returns {object} Object containing background, backgroundImage, and borderColor styles
 */
export const getActiveColorStyle = (activeColor = "primary") => {
  const colorMap = {
    primary: {
      background: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-states) 50%, var(--theme-primary) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-states) 50%, var(--theme-primary) 100%)',
      borderColor: 'var(--theme-primary-states)'
    },
    secondary: {
      background: 'linear-gradient(135deg, var(--theme-secondary) 0%, var(--theme-secondary-states) 50%, var(--theme-secondary) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-secondary) 0%, var(--theme-secondary-states) 50%, var(--theme-secondary) 100%)',
      borderColor: 'var(--theme-secondary-states)'
    },
    tertiary: {
      background: 'linear-gradient(135deg, var(--theme-tertiary) 0%, var(--theme-tertiary-states) 50%, var(--theme-tertiary) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-tertiary) 0%, var(--theme-tertiary-states) 50%, var(--theme-tertiary) 100%)',
      borderColor: 'var(--theme-tertiary-states)'
    },
    quaternary: {
      background: 'linear-gradient(135deg, var(--theme-quaternary) 0%, var(--theme-quaternary-states) 50%, var(--theme-quaternary) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-quaternary) 0%, var(--theme-quaternary-states) 50%, var(--theme-quaternary) 100%)',
      borderColor: 'var(--theme-quaternary-states)'
    },
    quinary: {
      background: 'linear-gradient(135deg, var(--theme-quinary) 0%, var(--theme-quinary-states) 50%, var(--theme-quinary) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-quinary) 0%, var(--theme-quinary-states) 50%, var(--theme-quinary) 100%)',
      borderColor: 'var(--theme-quinary-states)'
    },
    fifth: {
      background: 'linear-gradient(135deg, var(--theme-fifth) 0%, var(--theme-fifth-states) 50%, var(--theme-fifth) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-fifth) 0%, var(--theme-fifth-states) 50%, var(--theme-fifth) 100%)',
      borderColor: 'var(--theme-fifth-states)'
    },
    sixth: {
      background: 'linear-gradient(135deg, var(--theme-sixth) 0%, var(--theme-sixth-states) 50%, var(--theme-sixth) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-sixth) 0%, var(--theme-sixth-states) 50%, var(--theme-sixth) 100%)',
      borderColor: 'var(--theme-sixth-states)'
    },
    seventh: {
      background: 'linear-gradient(135deg, var(--theme-seventh) 0%, var(--theme-seventh-states) 50%, var(--theme-seventh) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-seventh) 0%, var(--theme-seventh-states) 50%, var(--theme-seventh) 100%)',
      borderColor: 'var(--theme-seventh-states)'
    },
    eighth: {
      background: 'linear-gradient(135deg, var(--theme-eighth) 0%, var(--theme-eighth-states) 50%, var(--theme-eighth) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-eighth) 0%, var(--theme-eighth-states) 50%, var(--theme-eighth) 100%)',
      borderColor: 'var(--theme-eighth-states)'
    },
    ninth: {
      background: 'linear-gradient(135deg, var(--theme-ninth) 0%, var(--theme-ninth-states) 50%, var(--theme-ninth) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-ninth) 0%, var(--theme-ninth-states) 50%, var(--theme-ninth) 100%)',
      borderColor: 'var(--theme-ninth-states)'
    },
    tenth: {
      background: 'linear-gradient(135deg, var(--theme-tenth) 0%, var(--theme-tenth-states) 50%, var(--theme-tenth) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-tenth) 0%, var(--theme-tenth-states) 50%, var(--theme-tenth) 100%)',
      borderColor: 'var(--theme-tenth-states)'
    },
    blue: {
      background: 'linear-gradient(135deg, var(--theme-tertiary) 0%, var(--theme-tertiary-states) 50%, var(--theme-tertiary) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-tertiary) 0%, var(--theme-tertiary-states) 50%, var(--theme-tertiary) 100%)',
      borderColor: 'var(--theme-tertiary-states)'
    },
    custom: {
      background: 'linear-gradient(135deg, var(--theme-custom) 0%, var(--theme-custom-states) 50%, var(--theme-custom) 100%)',
      backgroundImage: 'linear-gradient(135deg, var(--theme-custom) 0%, var(--theme-custom-states) 50%, var(--theme-custom) 100%)',
      borderColor: 'var(--theme-custom-states)'
    }
  };
  return colorMap[activeColor] || colorMap.secondary;
};

/**
 * Utility function to get button color based on activeColor (used in Footer component)
 * @param {string} activeColor - The active color theme
 * @returns {string} Color value for buttons
 */
export const getButtonColor = (activeColor = "secondary") => {
  const colorMap = {
    primary: 'var(--theme-primary)',
    secondary: 'var(--theme-secondary)',
    tertiary: 'var(--theme-tertiary)',
    blue: 'var(--theme-tertiary)',
    quaternary: 'var(--theme-quaternary)',
    quinary: 'var(--theme-quinary)',
    fifth: 'var(--theme-fifth)',
    sixth: 'var(--theme-sixth)',
    seventh: 'var(--theme-seventh)',
    eighth: 'var(--theme-eighth)',
    ninth: 'var(--theme-ninth)',
    tenth: 'var(--theme-tenth)',
    custom: 'var(--theme-custom)'
  };
  return colorMap[activeColor] || colorMap.secondary;
}; 